/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-plusplus */
import { Button, Grid, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import PopupText from '../common/PopupText';
import PopupTextField from '../common/PopupTextField';
import PopupDropDown from '../common/PopupDropDown';
import UploadField from '../common/UploadField';
import UploadAnimField from '../common/UploadAnimField';
import { getAllBadges, getBadgeTypeList, showProgress } from '../../redux/actions/DealershipActions';
import UploadUnlockField from '../common/UploadUnlockField';
import Theme from '../ui/Theme';
import service from '../../apis/service';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import Modal from '../common/Modal';
import { apiEndpoints } from '../../constants/apiEndpoints';
const FormData = require('form-data');

toast.configure();
const useStyles = makeStyles(() => ({
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
  },
  badgeId: {
    fontSize: '12px',
    fontWeight: '500',
    marginTop: '-7px',
  },
  popSubmitBtn: {
    padding: '0 70px',
    height: '45px',
    width: '200px',
  },
  popCancelBtn: {
    padding: '0 70px',
    height: '45px',
    width: '200px',
    marginRight: '28px',
  },
  popupMainContainer: {
    marginTop: '10px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
}));

const BadgeAddNewPopup = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const selectedType = useSelector((state) => state.getSelectedBadgeType);
  const [data, setData] = useState({});
  const [lockedThumbnail, setLockedThumbnail] = useState('');
  const [unlockedThumbnail, setUnlockedThumbnail] = useState('');
  const [animThumbnail, setAnimThumbnail] = useState('');
  const dropdownTypeList = [
    { id: 1, title: 'Story' },
    { id: 2, title: 'Guide' },
    { id: 3, title: 'Streak' },
  ];
  const dropdownBreakpoint = [];
  for (let index = 1; index <= 5000; index++) {
    if (index > 100) {
      index += 24;
    }
    dropdownBreakpoint.push({ id: index, title: index.toString() });
  }
  useEffect(() => {
    if (props.edit === true) {
      dispatch(showProgress(true));
      getBadgeDetails();
    }
  }, []);
  const getBadgeDetails = async () => {
    await service
      .get(apiEndpoints.BADGES_UPDATE_BADGE.replace('BADGE_ID', props.id))
      .then((res) => {
        res.breakpoint = res.breakpoint.toString();
        if (res.type === 'dose') {
          res.type = 'Story';
        } else {
          res.type = res.type.charAt(0).toUpperCase() + res.type.slice(1);
        }
        setData(res);
        setLockedThumbnail(res.lockedImageUrl);
        setUnlockedThumbnail(res.unlockedImageUrl);
        setAnimThumbnail(res.animationUrl);
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };

  const handleData = ({ target }) => {
    if (target.name === 'lockedImage' || target.name === 'unlockedImage' || target.name === 'animation') {
      const filesData = target.files[0];
      setData({
        ...data,
        [target.name]: filesData,
      });
      const reader = new FileReader();
      reader.onload = (ev) => {
        if (target.name === 'lockedImage') setLockedThumbnail(ev.target.result);
        else if (target.name === 'unlockedImage') setUnlockedThumbnail(ev.target.result);
        else if (target.name === 'animation') setAnimThumbnail(ev.target.result);
      };
      reader.readAsDataURL(target.files[0]);
    } else if (target.name === 'type') {
      if (target.value.toLowerCase() === 'story') {
        setData({
          ...data,
          [target.name]: 'dose',
        });
      } else {
        setData({
          ...data,
          [target.name]: target.value.toLowerCase(),
        });
      }
    } else {
      setData({
        ...data,
        [target.name]: target.value,
      });
    }
  };
  const submitBadge = async () => {
    const formData = new FormData();
    if (data.type === 'Story') {
      data.type = 'dose';
    }
    let tempType = '';
    let tempSelectedType = '';
    if (data.type === 'Story') {
      tempType = 'dose';
    } else {
      tempType = data.type?.toLowerCase();
    }
    if (selectedType === 'story') {
      tempSelectedType = 'dose';
    } else {
      tempSelectedType = selectedType;
    }
    if (props.edit === false) {
      Object.keys(data).forEach((value) => {
        formData.append(value, data[value]);
      });
      dispatch(showProgress(true));
      await service
        .post(apiEndpoints.BADGES_CREATE_BADGE, formData)
        .then((response) => {
          notifySuccess('Saved Successfully');
          dispatch(showProgress(false));
          if (props.edit === false) {
            dispatch(getBadgeTypeList('IncreaseBadgeCount', tempType.toLowerCase()));
            if (tempSelectedType.toLowerCase() === tempType) {
              dispatch(getAllBadges('append', response));
            }
          }
          props.close();
        })
        .catch((error) => {
          dispatch(showProgress(false));
          ErrorToast(error);
        });
    } else {
      delete data.id;
      delete data.lockedImageUrl;
      delete data.unlockedImageUrl;
      delete data.animationUrl;
      Object.keys(data).forEach((value) => {
        formData.append(value, data[value]);
      });
      dispatch(showProgress(true));
      await service
        .put(apiEndpoints.BADGES_UPDATE_BADGE.replace('BADGE_ID', props.id), formData)
        .then((response) => {
          notifySuccess('Saved Successfully');
          dispatch(showProgress(false));
          if (tempSelectedType.toLowerCase() === tempType) {
            dispatch(getAllBadges('update', response));
          } else {
            dispatch(getAllBadges('remove', response));
            dispatch(getBadgeTypeList('DecreaseBadgeCount', tempSelectedType.toLowerCase()));
            dispatch(getBadgeTypeList('IncreaseBadgeCount', tempType.toLowerCase()));
          }
          props.close();
        })
        .catch((error) => {
          dispatch(showProgress(false));
          ErrorToast(error);
        });
    }
  };
  return (
    <Modal isOpen height="68vh" width="850px">
      <Grid container>
        <Grid container direction="row">
          <Grid item xs={11}>
            <Grid container direction="column">
              <Grid item className={classes.popupHeading}>
                {props.edit ? 'Edit Badge' : 'Add Badge'}
              </Grid>
              <Grid item className={classes.badgeId}>
                {props.edit && `Badge Id: ${data.id ? data.id : ''}`}
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={1}>
            <CloseIcon className={classes.popupCloseBtn} onClick={props.close} />
          </Grid>
        </Grid>
        <Grid container direction="row" className={classes.popupMainContainer}>
          <Grid item xs={6}>
            <Grid container direction="column">
              <Grid item>
                <PopupText text="Badge Name" required />
              </Grid>
              <Grid item>
                <PopupTextField
                  name="name"
                  rows={1}
                  placeholder="BADGE NAME"
                  id="badge_id"
                  height="45"
                  handleChange={handleData}
                  value={data.name}
                />
              </Grid>
              <Grid item>
                <PopupText text="Unlock Count" required />
              </Grid>
              <Grid item>
                <PopupDropDown
                  name="breakpoint"
                  handleChange={handleData}
                  value={data.breakpoint}
                  list={dropdownBreakpoint}
                  height="43px"
                  width="343px"
                />
              </Grid>
              <Grid item>
                <PopupText text="Unlocked badge description" required />
              </Grid>
              <Grid item>
                <PopupTextField
                  name="unlockedDescription"
                  rows={4}
                  placeholder="Text Here"
                  id="unlock_badge_desc_id"
                  height="64"
                  handleChange={handleData}
                  value={data.unlockedDescription}
                />
              </Grid>
              <Grid item>
                <PopupText text="Locked badge description" required />
              </Grid>
              <Grid item>
                <PopupTextField
                  name="lockedDescription"
                  rows={4}
                  placeholder="Text Here"
                  id="lock_badge_desc_id"
                  height="64"
                  handleChange={handleData}
                  value={data.lockedDescription}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container direction="column">
              <Grid item>
                <PopupText text="Badge Type" required />
              </Grid>
              <Grid item>
                <PopupDropDown
                  handleChange={handleData}
                  value={data.type === 'dose' ? 'Story' : data.type?.charAt(0).toUpperCase() + data.type?.slice(1)}
                  list={dropdownTypeList}
                  height="43px"
                  width="343px"
                  marginBottom="20px"
                  name="type"
                />
              </Grid>
              <Grid item>
                <PopupText text="Badge Locked Image" required />
              </Grid>
              <Grid item>
                <UploadField name="lockedImage" value={lockedThumbnail} handleChange={handleData} />
              </Grid>
              <Grid item>
                <PopupText text="Badge Unlocked Image" required />
              </Grid>
              <Grid item>
                <UploadUnlockField name="unlockedImage" value={unlockedThumbnail} handleChange={handleData} />
              </Grid>
              <Grid item>
                <PopupText text="Badge Animation" required />
              </Grid>
              <Grid item>
                <UploadAnimField name="animation" value={animThumbnail} handleChange={handleData} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container justifyContent="center" alignItems="center">
          <Button variant="contained" className={classes.popCancelBtn} onClick={props.close}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" className={classes.popSubmitBtn} onClick={submitBadge}>
            Save
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default BadgeAddNewPopup;
